

























































































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '~/utils/nuxt3-migration'
import PendingAppointmentScheduleItemFooter from '~/components/shared/audits/request/timeline/PendingAppointmentScheduleItemFooter.vue'
import CancelledItemFooter from '~/components/shared/audits/request/timeline/CancelledItemFooter.vue'
import AuditPendingApprovalItemFooter from '~/components/shared/audits/request/timeline/AuditPendingApprovalItemFooter.vue'
import PendingAudittemFooter from '~/components/shared/audits/request/timeline/PendingAudittemFooter.vue'
import PendingAuditItemFooter from '~/components/shared/audits/request/timeline/PendingAuditItemFooter.vue'
import AuditCompletedScheduleItemFooter from '~/components/shared/audits/request/timeline/AuditCompletedScheduleItemFooter.vue'
import {
  AuditActingUser,
  AuditRequest,
  AuditRequestStatusStatus
} from '~/models/audit/request'
import { AUDIT_REQUEST_FAILED_STATUSES } from '~/constants/audits/request'

export default defineComponent({
  components: {
    AuditCompletedScheduleItemFooter,
    PendingAuditItemFooter,
    PendingAudittemFooter,
    AuditPendingApprovalItemFooter,
    CancelledItemFooter,
    PendingAppointmentScheduleItemFooter
  },
  props: {
    auditRequest: {
      type: Object as PropType<AuditRequest>,
      required: true
    },
    status: {
      type: String as PropType<AuditRequestStatusStatus>,
      required: true
    },
    showFallbacks: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { auditRequest } = toRefs(props)

    const userIsAuditProvider = computed(
      () =>
        auditRequest.value.currentUserRole === AuditActingUser.AUDIT_PROVIDER
    )

    const userIsPayer = computed(
      () => auditRequest.value.currentUserRole === AuditActingUser.PAYER
    )

    const userIsSeller = computed(
      () => auditRequest.value.currentUserRole === AuditActingUser.SELLER
    )

    return {
      userIsAuditProvider,
      userIsPayer,
      userIsSeller,
      AuditRequestStatusStatus,
      AUDIT_REQUEST_FAILED_STATUSES
    }
  }
})
